import React from "react"
import Auth from "../../ui/Auth"
import { useQuery } from "lib"
import { Entity, Region } from "ui"

const footerQuery = {
    collection: "site",
    query: {
        type: "footer",
    },
}
const footerConfig = { setEntityInfo: true, single: true }

const Footer = ({ node, language }) => {
    const [entity] = useQuery(footerQuery, footerConfig)
    const info = { language }
    if (!node) return null
    return (
        <footer id="footer">
            <div className="footer-in">
                <Entity entity={entity} info={info}>
                    {info => <Region entity={entity} language={language} dynamic />}
                </Entity>
                <div className="copyright">Copyright © 1993-2019 MPI Steel Process</div>

                <Auth />
            </div>
        </footer>
    )
}
export default React.memo(Footer)
